<div class="dialog-header">
  @if(data.severity === 'warning' || !data.severity) {
    <div class="dialog-icon-wrapper">
      <div class="dialog-icon warning-bg">
        <i class="fa-solid fa-triangle-exclamation icon-warning"></i>
      </div>
      <div>
        <h2 class="dialog-title">{{ data.title || 'Are you sure?' }}</h2>
        <p class="dialog-subtitle">{{ data.subtitle || 'This action requires confirmation' }}</p>
      </div>
    </div>
    <button class="dialog-close" (click)="onCancel()">
      <i class="fa-solid fa-xmark"></i>
    </button>
  }
  @if(data.severity === 'danger') {
    <div class="dialog-icon-wrapper">
      <div class="dialog-icon danger-bg">
        <i class="fa-solid fa-triangle-exclamation icon-danger"></i>
      </div>
      <div>
        <h2 class="dialog-title">{{ data.title || 'Warning!' }}</h2>
        <p class="dialog-subtitle">{{ data.subtitle || 'This action cannot be undone' }}</p>
      </div>
    </div>
    <button class="dialog-close" (click)="onCancel()">
      <i class="fa-solid fa-xmark"></i>
    </button>
  }
  @if(data.severity === 'info') {
    <div class="dialog-icon-wrapper">
      <div class="dialog-icon new">
        <i class="fa-solid fa-circle-info"></i>
      </div>
      <div>
        <h2 class="dialog-title">{{ data.title || 'Confirm' }}</h2>
        <p class="dialog-subtitle">{{ data.subtitle || 'Please confirm your action' }}</p>
      </div>
    </div>
    <button class="dialog-close" (click)="onCancel()">
      <i class="fa-solid fa-xmark"></i>
    </button>
  }
</div>

<mat-dialog-content class="dialog-body">
  <p>{{ data.message }}</p>
</mat-dialog-content>

<div class="dialog-footer">
  <button class="btn-ghost" (click)="onCancel()">
    {{ data.cancelText || 'Cancel' }}
  </button>
  <button
    class="btn-primary"
    [ngClass]="{
      'btn-danger': data.severity === 'danger',
      'btn-warning': data.severity === 'warning'
    }"
    (click)="onConfirm()">
    {{ data.confirmText || 'Confirm' }}
  </button>
</div>
